import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material';

import scssVariables from 'styles/sass-variables.module.scss';

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  borderRadius: '8px !important',
  border: `1px solid ${scssVariables.greys_border}`,
  
  '&.Mui-expanded': {
    border: `1px solid ${scssVariables.primary_purple_default}`,
  }
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  padding: '0 12px',
  margin: 0,

  '&.Mui-expanded': {
    minHeight: '56px',
  },
  
  '& .MuiAccordionSummary-content': {
    margin: 0,
    
    '&.Mui-expanded': {
      color: scssVariables.primary_purple_default,
      minHeight: '56px',
      margin: 0,
    },
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({}));
